/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialPaymentMethodViewModel } from "../types/CourseFinancialPaymentMethodViewModel.ts";
import { ePaymentMethodSchema } from "./ePaymentMethodSchema.ts";

export const courseFinancialPaymentMethodViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da forma de pagamento do plano."),
  ),
  paymentMethod: z.optional(
    z
      .lazy(() => ePaymentMethodSchema)
      .describe(
        "1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay | ",
      ),
  ),
  isInstallment: z.optional(
    z.boolean().describe("Indica se a forma de pagamento é parcelada."),
  ),
  numberParcels: z
    .number()
    .int()
    .describe("Número de parcelas. Nulo quando não é parcelado.")
    .nullish(),
  fixParcelNumber: z.optional(
    z.boolean().describe("Indica se o número de parcelas é fixo."),
  ),
  hasEnrollmentUsage: z.optional(
    z
      .boolean()
      .describe(
        "Indica que a forma de pagamento já foi usada em uma matrícula. Nesse caso ela não pode ser removida nem trocada.",
      ),
  ),
  supportsInstallment: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a forma de pagamento aceita parcelamento. Só cartão de crédito MundiPagg e PecegePay aceitam.",
      ),
  ),
}) as unknown as ToZod<CourseFinancialPaymentMethodViewModel>;
